import { render, staticRenderFns } from "./studentDialog.vue?vue&type=template&id=b5eff7ec"
import script from "./studentDialog.vue?vue&type=script&lang=js"
export * from "./studentDialog.vue?vue&type=script&lang=js"
import style0 from "./studentDialog.vue?vue&type=style&index=0&id=b5eff7ec&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports